import { InjectionToken } from '@angular/core';
import { TaskListHeader } from 'src/app/models/domain';
import { PagedCollection } from 'src/app/state';

export const TECHNICAL_SPECIFICATION_PAGINATOR = new InjectionToken(
  'TECHNICAL_SPECIFICATION_PAGINATOR',
  {
    factory: () => new PagedCollection<TaskListHeader>(),
    providedIn: 'root',
  }
);
